"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _paginationModule = _interopRequireDefault(require("./pagination.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcPagination(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_paginationModule["default"].pagination)
  }, /*#__PURE__*/_react["default"].createElement(_lib.Pagination, {
    showSizeChanger: props === null || props === void 0 ? void 0 : props.showSizeChanger,
    title: props.title,
    defaultCurrent: props.defaultCurrent,
    defaultPageSize: props.defaultPageSize,
    disabled: props.disabled,
    hideOnSinglePage: props.hideOnSinglePage,
    pageSize: props.pageSize,
    responsive: props.responsive,
    showLessItems: props.showLessItems,
    showQuickJumper: props.showQuickJumper,
    showTitle: props.showTitle,
    showTotal: function showTotal(total, range) {
      return "".concat(range[0], "-").concat(range[1], " of ").concat(total, " records");
    },
    simple: props.simple,
    total: props.total,
    onChange: props.onChange,
    onShowSizeChange: props.onShowSizeChange,
    size: props.size,
    current: props.current
  }));
}
var _default = ArcPagination;
exports["default"] = _default;